export enum OlaType {
  NietPubliceerbaar = 'NIET_PUBLICEERBAAR',
  GevraagdInhoudelijkNazichtBezig = 'GEVRAAGD_INHOUDELIJK_NAZICHT_BEZIG',
  TegenstellingenGevonden = 'TEGENSTELLINGEN_GEVONDEN',
  ControleerHetGekozenJobdomein = 'CONTROLEER_GEKOZEN_JOBDOMEIN',
  GeenAutomatischeVerzendingMogelijk = 'GEEN_AUTOMATISCHE_VERZENDING_MOGELIJK'
}
